'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var mplTokenMetadata = require('@metaplex-foundation/mpl-token-metadata');
var assert = require('../../../utils/assert.cjs');
var common = require('../../../utils/common.cjs');
var Pda = require('../../../types/Pda.cjs');
var BigNumber = require('../../../types/BigNumber.cjs');

/** @group Models */

/** @group Model Helpers */
const isMetadata = value => typeof value === 'object' && value.model === 'metadata';

/** @group Model Helpers */
function assertMetadata(value) {
  assert["default"](isMetadata(value), `Expected Metadata model`);
}

/** @group Model Helpers */
const toMetadata = (account, json) => ({
  model: 'metadata',
  address: Pda.Pda.find(account.owner, [Buffer.from('metadata', 'utf8'), account.owner.toBuffer(), account.data.mint.toBuffer()]),
  mintAddress: account.data.mint,
  updateAuthorityAddress: account.data.updateAuthority,
  json: json ?? null,
  jsonLoaded: json !== undefined,
  name: common.removeEmptyChars(account.data.data.name),
  symbol: common.removeEmptyChars(account.data.data.symbol),
  uri: common.removeEmptyChars(account.data.data.uri),
  isMutable: account.data.isMutable,
  primarySaleHappened: account.data.primarySaleHappened,
  sellerFeeBasisPoints: account.data.data.sellerFeeBasisPoints,
  editionNonce: account.data.editionNonce,
  creators: account.data.data.creators ?? [],
  tokenStandard: account.data.tokenStandard,
  collection: account.data.collection ? {
    ...account.data.collection,
    address: account.data.collection.key
  } : null,
  collectionDetails: account.data.collectionDetails ? {
    version: account.data.collectionDetails.__kind,
    size: BigNumber.toBigNumber(account.data.collectionDetails.size)
  } : null,
  uses: account.data.uses ? {
    ...account.data.uses,
    remaining: BigNumber.toBigNumber(account.data.uses.remaining),
    total: BigNumber.toBigNumber(account.data.uses.total)
  } : null,
  programmableConfig: account.data.programmableConfig
});
const isNonFungible = nftOrSft => nftOrSft.tokenStandard === null || nftOrSft.tokenStandard === mplTokenMetadata.TokenStandard.NonFungible || nftOrSft.tokenStandard === mplTokenMetadata.TokenStandard.NonFungibleEdition || nftOrSft.tokenStandard === mplTokenMetadata.TokenStandard.ProgrammableNonFungible;
const isProgrammable = nftOrSft => nftOrSft.tokenStandard === mplTokenMetadata.TokenStandard.ProgrammableNonFungible;

exports.assertMetadata = assertMetadata;
exports.isMetadata = isMetadata;
exports.isNonFungible = isNonFungible;
exports.isProgrammable = isProgrammable;
exports.toMetadata = toMetadata;
//# sourceMappingURL=Metadata.cjs.map
